import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import ataEncaminhamentosService from "services/AtaEncaminhamentosService";
import { SignOut, Trash } from "@phosphor-icons/react";

const DeleteUserRoleModal = ({ show, onCloseClick, onDeleteClick, data }) => {
	return (
		<Modal
			size="sm"
			isOpen={show}
			toggle={onCloseClick}
			centered={true}
			style={{ minWidth: 700 }}
		>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16">
						Tem certeza que deseja excluir a função?
					</p>
					<p className="text-muted font-size-16 fw-bold flex">
						{data?.name}
					</p>

					<div className="hstack gap-2 justify-content-center mb-0">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={() => onDeleteClick(data.id)}
						>
							<Trash size={16} /> Excluir
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

DeleteUserRoleModal.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
	onDeleteClick: PropTypes.func,
	data: PropTypes.any,
};

export default DeleteUserRoleModal;
